import { render, staticRenderFns } from "./NewsMain.vue?vue&type=template&id=6e7baa23&"
import script from "./NewsMain.vue?vue&type=script&lang=js&"
export * from "./NewsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports